import * as Highcharts from 'highcharts';
import * as HighchartsBorderRadius from 'highcharts-rounded-corners';
import * as moment from 'moment';
import { TooltipDirective } from 'ng2-tooltip-directive';
import * as _ from 'underscore';

import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';

HighchartsBorderRadius(Highcharts);

@Component({
	selector: 'app-tv-daily-metrics',
	styleUrls: ['./tv-daily-metrics.component.css'],
	templateUrl: './tv-daily-metrics.component.html'
})
export class TvDailyMetricsComponent implements OnInit, WidgetCore, OnDestroy {
	@ViewChildren(TooltipDirective) tooltipDirective;

	public reloadSubscription;
	@Input() sectiontitle: string;
	@Input() creativestats: any;
	@Input() legend: any;
	@Input() colorsconfig: any;
	@Input() key: any;
	@Input() chartconfiguration: any;
	@Input() downloadconfig: string;
	@Input() sectionclass: string;
	public chartConfig: any;

	public secondaryColor = '#d8d8d8';
	public newGraphData = {};
	public selectedLegend;
	public selectedBar = null;
	public dateArray: any;
	public selectedMetrics: any;
	public barGraphData = {};
	public showLoad: any;
	public hasData: any;
	public responseData: any;
	public colorPalette: ColorPalette;
	public bgColor: any;
	public oppColor: any;
	public chartObj: any;
	public showMetrics = false;
	public dateRange: string;
	public colorsArray = [];
	public tooltipid: any;
	public tooltipShown = false;
	public downloadConfiguration: DownloadConfig;
	public hasUnkownValues: boolean;
	public isR103: boolean;
	public displayOrder = {
		Day: 2,
		'Early Fringe': 3,
		'Late Fringe': 6,
		Morning: 1,
		Overnight: 7,
		Prime: 5,
		'Prime Access': 4,
		Unknown: 100
	};
	@ViewChild('graphArea', { static: true }) graphElement: ElementRef;
	public tooltipOptions = {
		placement: 'top',
		theme: 'light'
	};
	public partnerName: string;
	public downloadIcon: any = false;
	private dataLength = 0;
	private stepCount;
	private pointsCount;
	private leftExtreme = 0;
	private rightExtreme = 0;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
			this.showMetrics = false;
		});
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
	}
	processResponseData(): void {}
	toggleTooltip(id: any): void {
		if (this.tooltipShown) {
			this.tooltipid = this.tooltipDirective.find((elem) => elem.id === id);
			this.tooltipid.hide();
			this.tooltipShown = false;
		} else {
			this.tooltipid = this.tooltipDirective.find((elem) => elem.id === id);
			this.tooltipid.show();
			this.tooltipShown = true;
		}
	}
	requestData(): void {
		this.showLoad = true;
		this.hasData = true;
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.responseData = response.data;
				this.processLegendData();
				this.processBarChartData();
			} else {
				this.hasData = false;
			}
		});
	}

	ngOnInit(): void {
		this.partnerName = this.analyticsDataModel.partner.partnerName;
		this.isR103 =
			this.analyticsDataModel.config.directoryName === 'default-r103' ||
			this.analyticsDataModel.config.directoryName === 'entravision-r103'
				? true
				: false;
		this.legend = JSON.parse(decodeURI(this.legend));
		this.chartConfig = JSON.parse(decodeURI(this.chartconfiguration));
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.stepCount = this.chartConfig && this.chartConfig.stepCount ? this.chartConfig.stepCount : 87;
		this.pointsCount = this.chartConfig && this.chartConfig.pointsCount ? this.chartConfig.pointsCount : 8;
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;

		this.requestData();
	}

	processLegendData(): void {
		this.colorsArray = [];
		const unknownValues = _.reject(this.responseData[1].data, (value) => {
			return value['unknown'] == null;
		});
		this.legend[1].metrics = this.responseData[2].data;
		for (const legendObj of this.legend) {
			legendObj['selected'] = false;
		}
		this.legend[1].metrics.forEach((legendMetricObj, index) => {
			legendMetricObj['enabled'] = true;
			legendMetricObj.displayOrder = this.displayOrder[legendMetricObj.displayName]
				? this.displayOrder[legendMetricObj.displayName]
				: 9;
			if (legendMetricObj.displayName.toLowerCase().includes('unknown')) {
				legendMetricObj.enabled = unknownValues.length > 0 ? true : false;
			}
		});
		if (this.partnerName !== 'Midco') {
			this.legend[1].metrics = _.sortBy(this.legend[1].metrics, 'displayOrder');
		}
		this.legend[1].metrics.forEach((legendMetricObj, index) => {
			const color = legendMetricObj.displayName.toLowerCase().includes('unknown')
				? '#EFEFEF'
				: this.getColorFromColorConfig(index, 1);
			this.colorsArray.push(color);
		});
		this.selectedMetrics = this.legend[0].value;
		this.legend[0].selected = true;
		this.selectedLegend = this.legend[0];
	}

	processBarChartData(): void {
		let barGraph = {};
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		_.each(this.legend, (legend) => {
			for (const data of this.responseData) {
				if (data.field === legend['value']) {
					data['isStackedChart'] = legend['isStackedChart'];
				}
			}
		});
		barGraph = _.find(this.responseData, (obj: any): boolean => {
			return obj['field'] === self.selectedMetrics;
		});
		const sortedData = _.sortBy(barGraph['data'], (o: any): string => {
			return moment(o['date']).format('YYYY-MM-DD');
		});
		this.dateArray = _.pluck(sortedData, 'date');
		this.barGraphData['categories'] = _.pluck(sortedData, 'date');
		this.barGraphData['series'] = [];
		if (!barGraph['isStackedChart']) {
			const metricsData = _.pluck(sortedData, 'spot');
			this.generateColumGraphData(this.barGraphData, metricsData);
			this.newGraphData = this.barGraphData;
		} else {
			const seriesElements = [];
			let categories;
			for (let j = 0; j < this.selectedLegend.metrics.length; j++) {
				categories = [];
				const metricsData = _.pluck(sortedData, this.selectedLegend.metrics[j].value);
				this.newGraphData['series'] = [];
				const data = [];
				const seriesObj = {};
				const newMetrics = [];
				if (this.chartConfig && this.chartConfig.enableYAxisPlotlines) {
					for (let i = 0; i < this.barGraphData['categories'].length; i++) {
						if (moment(this.barGraphData['categories'][i], 'YYYY-MM-DD').weekday() === 1) {
							categories.push(-1);
							newMetrics.push(null);
							newMetrics.push(metricsData[i]);
							categories.push({
								date: this.dateArray[i],
								value: 'M'
							});
						} else {
							categories.push({
								date: this.dateArray[i],
								value: ''
							});
							newMetrics.push(metricsData[i]);
						}
					}
					for (let i = 0; i < newMetrics.length; i++) {
						const obj = {};
						if (categories[i].value === 'M') {
							obj['y'] = Number(newMetrics[i]);
							obj['color'] = this.getColors(j);
						} else {
							obj['y'] = Number(newMetrics[i]);
							obj['color'] = this.getColors(j);
						}
						data.push(obj);
					}
					this.barGraphData['plotOptions'] = {
						column: {
							stacking: 'normal'
						},
						series: {
							borderWidth: this.isR103 ? 1 : 0,
							pointWidth: 5,
							pointPadding: this.isR103 ? 0.05 : 0.25,
							groupPadding: this.isR103 ? 0.05 : 0.25,
							borderRadius: this.isR103 ? 5 : 0
						}
					};
				} else {
					for (let i = 0; i < this.barGraphData['categories'].length; i++) {
						categories.push({
							date: this.dateArray[i],
							value: this.dateArray[i]
						});
						data.push({ y: Number(metricsData[i]), toolTipData: this.selectedLegend.metrics[j].dayparttime });
					}
					this.barGraphData['plotOptions'] = {
						column: {
							stacking: 'normal'
						},
						series: {
							borderWidth: this.isR103 ? 1 : 0,
							pointPadding: this.isR103 ? 0.05 : 0.25,
							groupPadding: this.isR103 ? 0.05 : 0.25,
							borderRadius: this.isR103 ? 5 : 0
						}
					};
				}
				seriesObj['name'] = this.selectedLegend.metrics[j].displayName;
				seriesObj['data'] = data;
				seriesObj['color'] = this.getColors(j);
				if (this.chartConfig.seriesConfig.length > 0) {
					//find the configuration for color
					let seriesConfig: any = _.where(this.chartConfig.seriesConfig, { seriesName: seriesObj['name'] });
					if (seriesConfig.length > 0) {
						seriesObj['color'] = this.colorUtilityService.getRGBByColorType(
							this.colorPalette,
							seriesConfig[0].colorConfig.color,
							seriesConfig[0].colorConfig.opacity
						);
						seriesObj['index'] = seriesConfig[0].index;
					}
				}
				const seriesData = JSON.parse(JSON.stringify(seriesObj));
				seriesElements.push(seriesData);
			}
			const plotLinesObj = this.generatePlotLines(categories);
			this.barGraphData['categories'] = categories;
			this.barGraphData['plotLines'] = plotLinesObj.plotLines;
			this.barGraphData['series'] = seriesElements;
		}
		this.drawGraph();
	}

	generateColumGraphData(graphData: any, metricsData: any): void {
		const categories = [];
		this.newGraphData['series'] = [];
		const data = [];
		const seriesObj = {};
		const newMetrics = [];

		if (this.chartConfig && this.chartConfig.enableYAxisPlotlines) {
			for (let i = 0; i < graphData.categories.length; i++) {
				if (moment(graphData.categories[i], 'YYYY-MM-DD').weekday() === 1) {
					categories.push(-1);
					newMetrics.push(null);
					newMetrics.push(metricsData[i]);
					categories.push({
						date: this.dateArray[i],
						value: 'M'
					});
				} else {
					categories.push({
						date: this.dateArray[i],
						value: ''
					});
					newMetrics.push(metricsData[i]);
				}
			}
			for (let i = 0; i < newMetrics.length; i++) {
				const obj = {};
				if (categories[i].value === 'M') {
					obj['y'] = Number(newMetrics[i]);
					obj['color'] = this.colorPalette.primaryColor;
				} else {
					obj['y'] = Number(newMetrics[i]);
					obj['color'] = this.colorPalette.quaternaryColor;
				}
				data.push(obj);
			}
			this.barGraphData['plotOptions'] = {
				column: {
					stacking: 'normal'
				},
				series: {
					borderWidth: this.isR103 ? 1 : 0,
					pointWidth: 5,
					pointPadding: this.isR103 ? 0.05 : 0.25,
					groupPadding: this.isR103 ? 0.05 : 0.25,
					borderRadius: this.isR103 ? 5 : 0
				}
			};
		} else {
			for (let i = 0; i < this.barGraphData['categories'].length; i++) {
				categories.push({
					date: this.dateArray[i],
					value: this.dateArray[i]
				});
				data.push({ y: Number(metricsData[i]) });
			}
			this.barGraphData['plotOptions'] = {
				series: {
					pointPadding: this.isR103 ? 0.05 : 0.25,
					groupPadding: this.isR103 ? 0.05 : 0.25,
					borderRadius: this.isR103 ? 5 : 0
				}
			};
		}
		if (this.chartConfig.seriesConfig.length > 0) {
			//find the configuration for color
			let seriesConfig: any = _.where(this.chartConfig.seriesConfig, { seriesName: this.selectedLegend.displayName });
			if (seriesConfig.length > 0) {
				seriesObj['color'] = this.colorUtilityService.getRGBByColorType(
					this.colorPalette,
					seriesConfig[0].colorConfig.color,
					seriesConfig[0].colorConfig.opacity
				);
			}
		}
		seriesObj['name'] = this.selectedLegend.displayName;
		seriesObj['data'] = data;
		this.barGraphData['series'].push(seriesObj);
		const plotLinesObj = this.generatePlotLines(categories);
		this.barGraphData['categories'] = plotLinesObj.categories;
		this.barGraphData['plotLines'] = plotLinesObj.plotLines;
	}

	drawGraph(): void {
		this.bgColor = '#fff';
		this.oppColor = '#2e2e2e';
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		this.dataLength = this.newGraphData['categories'].length - 1;
		this.newGraphData['plotOptions']['series']['events'] = {
			// tslint:disable-next-line: object-literal-shorthand tslint:disable-next-line: only-arrow-functions
			mouseOut: function (): void {
				self.selectedBar = null;
			}
		};
		this.newGraphData['plotOptions']['series']['states'] = {
			// tslint:disable-next-line: object-literal-shorthand tslint:disable-next-line: only-arrow-functions
			inactive: {
				opacity: 1
			}
		};
		this.chartObj = Highcharts.chart(
			this.graphElement.nativeElement,
			{
				chart: {
					backgroundColor: this.bgColor,
					height: this.chartConfig && this.chartConfig.height ? this.chartConfig.height : 320,
					marginLeft: this.chartConfig && this.chartConfig.marginLeft ? this.chartConfig.marginLeft : 48,
					marginRight: 40,
					type: 'column'
				},
				credits: {
					enabled: false
				},
				legend: {
					enabled:
						this.chartConfig &&
						this.chartConfig.graphConfig &&
						this.chartConfig.graphConfig.legendConfig &&
						this.chartConfig.graphConfig.legendConfig.enable
							? true
							: false,
					itemMarginTop:
						this.chartConfig &&
						this.chartConfig.graphConfig &&
						this.chartConfig.graphConfig.legendConfig &&
						this.chartConfig.graphConfig.legendConfig.itemMarginTop
							? this.chartConfig.graphConfig.legendConfig.itemMarginTop
							: 0,
					verticalAlign: this.chartConfig.graphConfig.legendConfig.verticalAlign
						? this.chartConfig.graphConfig.legendConfig.verticalAlign
						: 'bottom',
					itemMarginBottom: this.chartConfig.graphConfig.legendConfig.itemMarginBottom
						? this.chartConfig.graphConfig.legendConfig.itemMarginBottom
						: '2'
				},
				plotOptions: this.newGraphData['plotOptions'],
				series:
					this.chartConfig && this.chartConfig.enableYAxisPlotlines
						? this.updateBorders(this.newGraphData['series'])
						: this.newGraphData['series'],
				title: {
					text: null
				},
				tooltip: {
					backgroundColor: '#fff',
					borderColor: this.secondaryColor,
					// tslint:disable-next-line: object-literal-shorthand tslint:disable-next-line: only-arrow-functions
					formatter: function (): string {
						self.highlightRespectiveDot(this.series['_i']);
						const customTooltip = this.point['toolTipData']
							? this.point['toolTipData'] + '<br/>' + this.y.toLocaleString() + ' Exposures'
							: `<b>${this.y.toLocaleString()}</b>`;
						return (
							// tslint:disable-next-line: prefer-template
							'<div class="tooltip" style="text-align:center; padding: 2px">' +
							this.series.name +
							'<br/>' +
							customTooltip +
							'<br/>' +
							moment(this.x['date'], 'YYYY-MM-DD').format('MM-DD-YY') +
							'</div>'
						);
					},
					useHTML: true
				},
				xAxis: {
					categories: this.newGraphData['categories'],
					gridLineColor: this.chartConfig && this.chartConfig.enableYAxisPlotlines ? this.bgColor : '#e6e6e6',
					labels: {
						// tslint:disable-next-line: object-literal-shorthand tslint:disable-next-line: only-arrow-functions
						formatter: function (): string {
							if (self.chartConfig && self.chartConfig.enableYAxisPlotlines) {
								return this.value['value'];
							}
							// tslint:disable-next-line: prefer-template
							return moment(this.value['value']).format('D') + '&middot;' + moment(this.value['value']).format('MMM');
						},
						overflow: 'allow',
						rotation:
							this.chartConfig &&
							this.chartConfig.graphConfig &&
							this.chartConfig.graphConfig.xAxisConfig &&
							this.chartConfig.graphConfig.xAxisConfig.labels &&
							this.chartConfig.graphConfig.xAxisConfig.labels.rotation
								? this.chartConfig.graphConfig.xAxisConfig.labels.rotation
								: 0,
						step: this.chartConfig && this.chartConfig.labelsStep ? this.chartConfig.labelsStep : 1,
						style: {
							color: '#000'
						},
						useHTML: true
					},
					lineColor: this.chartConfig && this.chartConfig.enableYAxisPlotlines ? this.bgColor : '#ccd6eb',
					lineWidth: this.chartConfig && this.chartConfig.enableYAxisPlotlines ? 0 : 1,
					minorGridLineWidth: this.chartConfig && this.chartConfig.enableYAxisPlotlines ? 0 : 1,
					minorTickLength: this.chartConfig && this.chartConfig.enableYAxisPlotlines ? 1 : 2,
					offset: this.chartConfig && this.chartConfig.enableYAxisPlotlines ? 5 : 0,
					plotLines: this.chartConfig && this.chartConfig.enableXAxisPlotlines ? this.newGraphData['plotLines'] : [],
					tickLength: this.chartConfig && this.chartConfig.enableYAxisPlotlines ? 1 : 10
				},
				yAxis: {
					gridLineColor: this.chartConfig && this.chartConfig.enableYAxisPlotlines ? this.bgColor : '#e6e6e6',
					labels:
						this.chartConfig && this.chartConfig.enableYAxisPlotlines
							? {
									align: 'left',
									enabled: true,
									x: -45
							  }
							: {
									// tslint:disable-next-line: object-literal-shorthand
									formatter: function (): string {
										if (this.value > 999) {
											return (Number(this.value) / 1000).toFixed(1) + 'k';
										}
										return String(this.value);
									}
							  },
					lineColor: this.chartConfig && this.chartConfig.enableYAxisPlotlines ? this.bgColor : '#ccd6eb',
					stackLabels: {
						enabled: false,
						style: {
							color: 'gray',
							fontWeight: 'bold'
						}
					},
					// tslint:disable-next-line: object-literal-shorthand
					tickPositioner: function (): any {
						const positions = [Math.floor(this.min), Math.ceil(this.max / 2), Math.floor(this.max)];
						if (self.chartConfig && self.chartConfig.enableYAxisPlotlines) {
							return positions;
						}
					},
					title: {
						text: this.chartConfig && this.chartConfig.enableYAxisTitle ? '<b>Exposures<b>' : '',
						y: -10
					}
				}
			},
			(chart: any) => {
				// on complete
				function noop(): void {}
				if (this.dataLength > this.stepCount) {
					this.leftExtreme = 0;
					this.rightExtreme = this.stepCount;
					const imageXvalueLeft = this.chartConfig && this.chartConfig.enableYAxisPlotlines ? '2%' : '0%';
					chart['left_img'] = chart.renderer
						.image('../../../../../assets/images/left_arrow.png', 0, 0, 9, 14)
						.on('click', () => {
							if (this.leftExtreme > this.pointsCount) {
								this.leftExtreme -= this.pointsCount;
								this.rightExtreme -= this.pointsCount;
								chart['left_img'].show();
								chart['right_img'].show();
							} else {
								this.leftExtreme = 0;
								this.rightExtreme = this.stepCount;
								chart['left_img'].hide();
								chart['right_img'].show();
							}
							// tslint:disable-next-line: no-shadowed-variable
							let startDate = '';
							// tslint:disable-next-line: no-shadowed-variable
							let endDate = '';
							if (
								moment(self.newGraphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								startDate = moment(self.newGraphData['categories'][this.leftExtreme + 1].date, 'YYYY-MM-DD').format(
									'M/DD/YYYY'
								);
							} else {
								startDate = moment(self.newGraphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format(
									'M/DD/YYYY'
								);
							}
							if (
								moment(self.newGraphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								endDate = moment(self.newGraphData['categories'][this.rightExtreme - 1].date, 'YYYY-MM-DD').format(
									'M/DD/YYYY'
								);
							} else {
								endDate = moment(self.newGraphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format(
									'M/DD/YYYY'
								);
							}
							this.dateRange = `${startDate} - ${endDate}`;
							chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
							chart.redraw();
						})
						.css({ cursor: 'pointer' })
						.attr('x', imageXvalueLeft)
						.attr('y', '50%')
						.add();
					const imageXvalueRight = this.chartConfig && this.chartConfig.enableYAxisPlotlines ? '98%' : '99%';
					chart['right_img'] = chart.renderer
						.image('../../../../../assets/images/right_arrow.png', 0, 0, 9, 14)
						.on('click', () => {
							if (this.dataLength - this.rightExtreme > this.pointsCount) {
								this.leftExtreme += this.pointsCount;
								this.rightExtreme += this.pointsCount;
								chart['left_img'].show();
								chart['right_img'].show();
							} else {
								this.leftExtreme = this.dataLength - this.stepCount;
								this.rightExtreme = this.dataLength;
								chart['left_img'].show();
								chart['right_img'].hide();
							}
							// tslint:disable-next-line: no-shadowed-variable
							let startDate = '';
							// tslint:disable-next-line: no-shadowed-variable
							let endDate = '';
							if (
								moment(self.newGraphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								startDate = moment(self.newGraphData['categories'][this.leftExtreme + 1].date, 'YYYY-MM-DD').format(
									'M/DD/YYYY'
								);
							} else {
								startDate = moment(self.newGraphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format(
									'M/DD/YYYY'
								);
							}
							if (
								moment(self.newGraphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								endDate = moment(self.newGraphData['categories'][this.rightExtreme - 1].date, 'YYYY-MM-DD').format(
									'M/DD/YYYY'
								);
							} else {
								endDate = moment(self.newGraphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format(
									'M/DD/YYYY'
								);
							}
							this.dateRange = `${startDate} - ${endDate}`;
							chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
							chart.redraw();
						})
						.css({ cursor: 'pointer' })
						.attr('x', imageXvalueRight)
						.attr('y', '50%')
						.add();
					let startDate = '';
					let endDate = '';
					if (
						moment(self.newGraphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						startDate = moment(self.newGraphData['categories'][this.leftExtreme + 1].date, 'YYYY-MM-DD').format(
							'M/DD/YYYY'
						);
					} else {
						startDate = moment(self.newGraphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format(
							'M/DD/YYYY'
						);
					}
					if (
						moment(self.newGraphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						endDate = moment(self.newGraphData['categories'][this.rightExtreme - 1].date, 'YYYY-MM-DD').format(
							'M/DD/YYYY'
						);
					} else {
						endDate = moment(self.newGraphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('M/DD/YYYY');
					}
					this.dateRange = `${startDate} - ${endDate}`;
					chart.xAxis[0].setExtremes(0, this.rightExtreme);
					chart['left_img'].hide();
					chart['right_img'].show();
					chart.redraw();
					chart['right_img'].translate(-10, 0);
					chart['left_img'].translate(10, 0);
				} else {
					this.leftExtreme = 0;
					this.rightExtreme = this.dataLength;
					let startDate = '';
					let endDate = '';

					if (
						moment(self.newGraphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						startDate = moment(self.newGraphData['categories'][this.leftExtreme + 1].date, 'YYYY-MM-DD').format(
							'M/DD/YYYY'
						);
					} else {
						startDate = moment(self.newGraphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format(
							'M/DD/YYYY'
						);
					}
					if (
						moment(self.newGraphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						endDate = moment(self.newGraphData['categories'][this.rightExtreme - 1].date, 'YYYY-MM-DD').format(
							'M/DD/YYYY'
						);
					} else {
						endDate = moment(self.newGraphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('M/DD/YYYY');
					}
					this.dateRange = `${startDate} - ${endDate}`;
					chart.xAxis[0].setExtremes(0, this.dataLength);
					if (chart['right_img'] && chart['left_img']) {
						chart['right_img'].hide();
						chart['left_img'].hide();
					}
				}
			}
		);
	}

	updateTooltipName(): string {
		return this.selectedLegend.displayName;
	}

	generatePlotLines(categories: any): any {
		const plotLines = [];
		const lineObj = {
			color: this.secondaryColor,
			dashStyle: 'ShortDash',
			label: {
				enabled: false
			},
			value: 0,
			width: 1
		};
		// tslint:disable-next-line: no-parameter-reassignment
		categories = categories.map((val, index) => {
			if (val === -1) {
				lineObj.value = index;
				plotLines.push(JSON.parse(JSON.stringify(lineObj)));
				return '';
			} else {
				return val;
			}
		});
		return { categories, plotLines };
	}

	processSelectedLegendItem(legendItem: any): void {
		this.selectedLegend = legendItem;
		for (const legendObj of this.legend) {
			legendObj.selected = false;
		}
		if (legendItem.isStackedChart && legendItem.showArrow) {
			this.showMetrics = true;
		} else {
			this.showMetrics = false;
		}

		const selectedLegend: any = _.findWhere(this.legend, { value: legendItem.value });
		selectedLegend.selected = true;
		this.selectedMetrics = selectedLegend.value;
		this.processBarChartData();
	}

	getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];

		const fillOpacity = colorConfig ? colorConfig.opacity : opacity;
		let rgb = '';
		if (colorConfig && colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else if (colorConfig && colorConfig.color) {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		} else if (index % 2 === 0) {
			const colorObj = this.colorsconfig[index % this.colorsconfig.length];
			const hexCode = !colorObj.isHex
				? this.colorUtilityService.getHEXByColorType(this.colorPalette, colorObj.color, colorObj.opacity)
				: colorObj.color;
			rgb = this.colorUtilityService.getBrightColor(hexCode, index, colorObj.opacity);
		} else if (index % 2 === 1) {
			const colorObj = this.colorsconfig[index % this.colorsconfig.length];
			const hexCode = !colorObj.isHex
				? this.colorUtilityService.getHEXByColorType(this.colorPalette, colorObj.color, colorObj.opacity)
				: colorObj.color;
			rgb = this.colorUtilityService.getDarkColor(hexCode, index, colorObj.opacity);
		}
		return rgb;
	}

	getColors(index: number): string {
		return this.colorsArray[index];
	}

	updateBorders(series: any): void {
		if (series.length > 1) {
			const first = _.first(series);
			first['borderRadiusTopLeft'] = '50%';
			first['borderRadiusTopRight'] = '50%';
			const last = _.last(series);
			last['borderRadiusBottomLeft'] = '50%';
			last['borderRadiusBottomRight'] = '50%';
		} else {
			const first = _.first(series);
			first['borderRadiusTopLeft'] = '50%';
			first['borderRadiusTopRight'] = '50%';
			first['borderRadiusBottomLeft'] = '50%';
			first['borderRadiusBottomRight'] = '50%';
		}
		return series;
	}

	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName
		);
	}

	highlightRespectiveDot(index: number): void {
		this.selectedBar = index;
	}
}
